'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'tag';
var width = 512;
var height = 512;
var aliases = [127991];
var unicode = 'f02b';
var svgPathData = 'M48.1 32l-16 0 0 246.6 4.7 4.7 224 224 11.3 11.3 11.3-11.3 235.3-235.3-11.3-11.3-224-224-4.7-4.7-230.6 0zm16 233.4l0-201.4 201.4 0 208 208-201.4 201.4-208-208zm80-97.4a24 24 0 1 0 0-48 24 24 0 1 0 0 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTag = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;